import {useState} from "react";
import {getCsrfToken, getUserName, setUserInfo} from "./App"

export function LoginPage() {
    const [userName, setUserName] = useState("");
    const [userPassword, setPassword] = useState("");
    const [loggedIn, setLoggedIn] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    function performLogin(e: React.MouseEvent | React.FormEvent) {
        const loginDetails = JSON.stringify({ user: userName, pass: userPassword });
        setErrorMessage("");
        getCsrfToken().then((csrfToken: string) => {
            fetch('/api/v1/auth/login', {
                method: 'POST', body: loginDetails, headers: {
                    'X-XSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }).then(response => {
                if (response.status === 401 || response.status === 403 || response.status === 404) {
                    setLoggedIn(false);
                    setErrorMessage("User or password incorrect, please try again.");
                    throw new Error("");
                } else if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.text();
            }).then(role => {
                setUserInfo(userName, role.replaceAll('"', ''));
                setLoggedIn(true)
            }).catch(e => {
                    setLoggedIn(false);
                    if (e.message.length === 0) return;
                    if (e.status === 404 || e.status === 401) {
                        setErrorMessage("User or password incorrect, please try again.");
                    } else {
                        setErrorMessage("Unknown error " + e.message);
                    }
                }
            );
        });
        e.preventDefault();
    }

    if(loggedIn) {
        return <div>
            <h1>Hi {getUserName()},</h1>
            <p>Thanks for logging back in, have a great day!</p>
        </div>
    }
    return <div>
        <h1>Login to NutriCherry</h1>
        {errorMessage?.length > 0 ? <p style={{color: 'red'}}>{errorMessage}</p> : ""}
        <p>Please login to NutriCherry. Currently, only administrators can login.</p>
        <form action="" method="post">
            <div>
                <label><span style={{display: 'inline-block', width: '100px'}}>User Name:</span><input type="text" name="username" onChange={e => setUserName(e.target.value)}/></label>
            </div>
            <div>
                <label><span style={{display: 'inline-block', width: '100px'}}>Password:</span><input type="password" name="password" onChange={e => setPassword(e.target.value)}/></label>
            </div>
            <button onClick={e => performLogin(e)}>Login</button>
        </form>
    </div>
 }